// src/store/index.js
import { xlog } from '@/utils/utils';
import Vue from 'vue';
import Vuex from 'vuex';
import CryptoJS from 'crypto-js'; // 引入加密库
import router from '@/router';


Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // token: localStorage.getItem('token') || '',            // 初始化时获取 token   
    // customer_code: localStorage.getItem('customer_code') || '',
    // customer_name: localStorage.getItem('customer_name') || '',
    // supplier: JSON.parse(localStorage.getItem('supplier')) || [],
    // baseColor: localStorage.getItem('savedColor') || '#181A30',
    tabs: [{ code: '1', label: '首页', component: 'MainPage/HomePage', s: 0 },],  // 主页的tabs
    cachedComponents: {},
    activeTab: '1',// 当前激活的tab
    tabHistory: ['1'],  // 记录tab访问历史
    baseColor: localStorage.getItem('baseColor') || '#181A30',
    loginedData: localStorage.getItem('token') || '',
    testApiUrl:localStorage.getItem('testUrl') || '',
    su_customer_code: '',
    su_supplier_data:[],
    supplier_list:[],    
    upload_accept:".bmp,.jpg,.jpeg,.png,.webp,.pdf",
    showTaskList: false // 控制任务列表 Popover 的显示
  },

  getters: {
    testApiUrl: (state) => state.testApiUrl,
    // supplier_list: (state) => state.supplier_list,
    getSuCustomer_code: (state) => state.su_customer_code,
    getSuSupplier_data: (state) => state.su_supplier_data,
    getSupplier_list: (state) => state.supplier_list,

    getToken(state, getters) {
      const decryptedData = getters.decryptLoginedData;
      return decryptedData.token;
    },
    getLoginedData(state) {
      return state.loginedData;
    },
    getCustomer_code(state, getters) {
      const decryptedData = getters.decryptLoginedData;
      return decryptedData.customer_code;
    },
    getCustomer_name(state, getters) {
      const decryptedData = getters.decryptLoginedData;
      return decryptedData.customer_name;
    },
    getSupplier(state, getters) {
      const decryptedData = getters.decryptLoginedData;
      return decryptedData.supplier;
    },
    getIs_supplier(state, getters) {
      const decryptedData = getters.decryptLoginedData;
      return decryptedData.is_supplier;
    },
    getUser_code(state, getters) {
      const decryptedData = getters.decryptLoginedData;
      return decryptedData.user_code;
    }, 
    getUser_name(state, getters) {
      const decryptedData = getters.decryptLoginedData;
      return decryptedData.user_name;
    },
    decryptLoginedData(state) {
      if (state.loginedData) {
        try {
          const Data = CryptoJS.AES.decrypt(state.loginedData, process.env.VUE_APP_API_BASE_URL); // 解密
          const decryptedData = JSON.parse(Data.toString(CryptoJS.enc.Utf8)) || {};
          return decryptedData;
        } catch (error) {
          // xlog('Decryption failed', error);  // 打印解密错误
          return {};  // 返回空对象，防止解密失败时出错
        }
      } else {
        xlog('No loginedData found');
        return {};  // loginedData 为空时返回空对象
      }
    },
    getbaseColor: (state) => state.baseColor,
    getTabs: (state) => state.tabs,
  },

  mutations: {
    SET_TEST_API_URL(state, url) {
      localStorage.setItem('testUrl', url);  // 保存到 localStorage
      state.testApiUrl = url;
    },
     SET_SHOW_TASK_LIST(state, value) {
      xlog('SET_SHOW_TASK_LIST1', value)
      state.showTaskList = value;
      xlog('SET_SHOW_TASK_LIST2', value)
    },
    setSuCustomerCode(state, code) {
      // console.log('setSuCustomer_code', code)
      state.su_customer_code = code;
    },
    setSuSupplierData(state, data) {
      // console.log('setSuSupplier_data', data)
      state.su_supplier_data = data;
    },
    setSupplierList(state, list) {
      state.supplier_list = list;
       const encrypted = CryptoJS.AES.encrypt(JSON.stringify(list), process.env.VUE_APP_API_BASE_URL).toString();
        localStorage.setItem('sl', encrypted);  // 保存到 localStorage
    },
    setLoginedData(state, data) {
      if (data) {
        const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.VUE_APP_API_BASE_URL).toString();
        localStorage.setItem('token', encrypted);  // 保存到 localStorage
        state.loginedData = encrypted;
        state.tabs = [{ code: '1', label: '首页', component: 'MainPage/HomePage' }] // 还原默认tabs
        state.activeTab = '1' // 还原默认activeTab
      }
    },
    setToken(state, token) {
      if (token) {
        //读取state.loginedData
        const Data = CryptoJS.AES.decrypt(state.loginedData, process.env.VUE_APP_API_BASE_URL); // 解密
        const decryptedData = JSON.parse(Data.toString(CryptoJS.enc.Utf8)) || {};
        //修改decryptedData的token
        decryptedData.token = token;
        //加密修改后的decryptedData
        const encrypted = CryptoJS.AES.encrypt(JSON.stringify(decryptedData), process.env.VUE_APP_API_BASE_URL).toString();
        //保存到localStorage
        localStorage.setItem('token', encrypted);  // 保存到 localStorage
        state.loginedData = encrypted;
      }
    },


    setTabs(state, newValue) {
      state.tabs = newValue; // 修改变量
    },
    setActiveTab(state, newValue) {
      state.activeTab = newValue; // 修改变量
      const index = state.tabHistory.indexOf(newValue);
      if (index !== -1) {
        state.tabHistory.splice(index, 1); // 如果已存在，先移除
      }
      state.tabHistory.push(newValue); // 添加到历史记录末尾
    },
    setCachedComponents(state, newValue) {
      state.cachedComponents = newValue; // 修改变量
    },


    // setCustomer_code(state, customer_code) {
    //   if (customer_code) {
    //     state.customer_code = customer_code;
    //     localStorage.setItem('customer_code', customer_code);  // 保存到 localStorage
    //   }
    // },
    // setCustomer_name(state, customer_name) {
    //   if (customer_name) {
    //     state.customer_name = customer_name;
    //     localStorage.setItem('customer_name', customer_name);  // 保存到 localStorage
    //   }
    // },
    // setSupplier(state, supplier) {
    //   if (supplier) {
    //     state.supplier = supplier;
    //     localStorage.setItem('supplier', JSON.stringify(supplier)); // 保存到 localStorage
    //   }
    // },
    setbaseColor(state, color) {
      // state.savedColor = color;
      if (color) {
        state.baseColor = color;
        localStorage.setItem('baseColor', color); // 同时保存到本地缓存
      } else {
        state.baseColor = '#181A30';
        localStorage.removeItem('baseColor'); // 同时保存到本地缓存
      }

    },
    clearAuth(state) {
      state.su_customer_code = '';
      state.supplier_list = [];
      state.loginedData = '';
      state.cachedComponents = {};
      localStorage.removeItem('token');
      localStorage.removeItem('sl');
    },

    closeTab(state, tabCode) {
      const index = state.tabs.findIndex(tab => tab.code === tabCode);
      if (index !== -1) {
        // 删除目标标签
        state.tabs[index].s = 1; // 找到目标标签的 code
        setTimeout(() => {

          if (state.cachedComponents[tabCode]) {
            delete state.cachedComponents[tabCode]; // 清除缓存
          }
          state.tabs.splice(index, 1);
          // 更新 tabHistory（移除关闭的tab）
          state.tabHistory = state.tabHistory.filter(code => code !== tabCode);

          // 切换到上一个访问的 tab
          if (state.tabHistory.length > 0) {
            state.activeTab = state.tabHistory[state.tabHistory.length - 1]; // 取最后访问的 tab
          } else {
            state.activeTab = '';  // 没有剩余 tab
          }
        }, 200);
        //   // 如果关闭的标签是当前激活的标签，更新 activeTab
        //   if (state.activeTab === tabCode) {
        //     if (state.tabs.length > 0) {
        //       if (index < state.tabs.length) {
        //         state.activeTab = state.tabs[index]?.code; // 选择关闭标签后的下一个标签
        //       } else {
        //         state.activeTab = state.tabs[index - 1]?.code; // 选择前一个标签
        //       }
        //     } else {
        //       state.activeTab = ''; // 如果没有剩余标签，清空 activeTab
        //     }
        //   }
        // }, 200);

      }
    },
    closeTabMore(state, tabCode) {
      const index = state.tabs.findIndex(tab => tab.code === tabCode);
      if (index !== -1) {
        // 删除目标标签    
        if (state.cachedComponents[tabCode]) {
          delete state.cachedComponents[tabCode]; // 清除缓存
        }
        state.tabs.splice(index, 1);
        // 更新 tabHistory（移除关闭的tab）
        state.tabHistory = state.tabHistory.filter(code => code !== tabCode);

        // 如果关闭的标签是当前激活的标签，更新 activeTab
        if (state.activeTab === tabCode) {
          if (state.tabHistory.length > 0) {
            state.activeTab = state.tabHistory[state.tabHistory.length - 1]; // 切换到最近访问的 tab
          } else {
            state.activeTab = '';  // 没有剩余 tab
          }
        }
      }
    }
  },
  actions: {
    updateApiBaseUrl({ commit }, url) {
      commit('SET_TEST_API_URL', url);
    },
    updateSuCustomer_code({ commit }, code) {
      commit('setSuCustomer_code', code);
    },
    updateSuSupplier_data({ commit }, data) {
      commit('setSuSupplier_data', data);
    },
    updateSupplierList({ commit }, list) {
      commit('setSupplierList', list);
    },

    login({ commit }, { token, customer_code, customer_name, supplier, is_supplier, user_code, user_name }) {
      commit('setLoginedData', { "token": token, "customer_code": customer_code, "customer_name": customer_name, "supplier": supplier, "is_supplier": is_supplier, "user_code": user_code, "user_name": user_name });
    },

    
    logout({ commit }) {
      commit('clearAuth');  // 清除登录状态
      router.push('/'); // 跳转到登录页面
    },
    savebaseColor({ commit }, color) {
      commit('setbaseColor', color);
    },
    updateTabs({ commit }, newValue) {
      commit('setTabs', newValue); // 提交 mutation 来修改 state
    },
    updateActiveTab({ commit }, newValue) {
      commit('setActiveTab', newValue); // 提交 mutation 来修改 state
    },
    closeTab({ commit }, tabCode) {
      commit('closeTab', tabCode); // 提交 mutation 来更新 tabs 和 activeTab
    },
    closeTabMore({ commit }, tabCode) {
      commit('closeTabMore', tabCode); // 提交 mutation 来更新 tabs 和 activeTab
    },
  }
});
